import { render, staticRenderFns } from "./XhProuctCate.vue?vue&type=template&id=ba1342a4&scoped=true"
import script from "./XhProuctCate.vue?vue&type=script&lang=js"
export * from "./XhProuctCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1342a4",
  null
  
)

export default component.exports